export const toTitleCase = (value: string): string => {
  if (!value) return '';

  return value
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const toSentenceCase = (value: string): string => {
  if (!value) return '';

  const formatted = value.toLowerCase().replace(/_/g, ' ').trim();
  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};

export const formatEnumLabel = (value: string): string => {
  const words = value.toLowerCase().replace(/_/g, ' ').split(' ');
  return words.map((word, index) => (index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word)).join(' ');
};

export const formatLegalAccountType = (type: string): string => {
  switch (type) {
    case 'ROTH_IRA':
      return 'Roth IRA';
    case 'SEP_IRA':
      return 'SEP IRA';
    case 'TRADITIONAL_IRA':
      return 'Traditional IRA';
    case 'TRADITIONAL_401K':
      return 'Traditional 401(k)';
    case 'ROTH_401K':
      return 'Roth 401(k)';
    case 'INHERITED_IRA':
      return 'Inherited IRA';
    default:
      return formatEnumLabel(type);
  }
};

export const formatTransactionType = (type: string): string => {
  switch (type) {
    case 'ALLOCATION_CHANGE':
      return 'Portfolio Changes';
    default:
      return formatEnumLabel(type);
  }
};
